import { RouteData } from "../../../data/routing/types";
import { RootState } from "../../reducers";

export const nextRouteSelector = (state: RootState): RouteData | undefined =>
  state.routing.nextRoute;

export const currentRouteSelector = (state: RootState): RouteData | undefined =>
  state.routing.currentRoute;
